import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'

const t = buildTranslate('dashboard_access.edit_role')

export const NavbarTitle = () => (
  <>
    <Text.SmallCaps3 tag="div" className="mb-xs" color="white">
      {t('configure')}
    </Text.SmallCaps3>
    <Text.Header4 tag="div" bold color="white">
      {t('title')}
    </Text.Header4>
  </>
)
